<template>
  <div class="list_index">
      <el-button type="primary" class="yl-button" icon="el-icon-plus" @click="edit">编辑</el-button>
      <el-table stripe border :data="tableData" :row-style="{height: '0'}" :cell-style="{padding: '10px'}">
          <el-table-column label="账号名称" prop="username" align="center"></el-table-column>
          <el-table-column label="账号密码" align="center">
              <template slot-scope="scope">
                  <p v-if="showPassword == false" @click="showPassword = true" style="cursor: pointer;">******</p>
                  <p v-else @click="showPassword = false" style="cursor: pointer;">{{scope.row.password}}</p>
              </template>
          </el-table-column>
      </el-table>
      <el-dialog :title="password == '' ? '新增账号':'修改账号'" :visible.sync="showDialog" width="30%">
      <el-form :model="form" label-position="right" label-width=".8rem" ref="edit" :rules="rules">
        <el-form-item label="账号名称" prop="username">
            <el-input type="text" size="small" placeholder="请输入账号名称" v-model="form.username" class="yl-input_noIcon"></el-input>
        </el-form-item>
        <el-form-item label="账号密码" prop="password">
            <el-input :type="passwordType" size="small" placeholder="请输入账号密码" v-model="form.password" class="yl-input_noIcon">
                <i slot="suffix" :class="icon_password" @click="showPasswords"></i>
            </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" class="yl-button" @click="submit()">确 定</el-button>
          <el-button @click="canel" class="yl-button2" size="mini">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
export default {
  data(){
      return{
          passwordType:'password',
          icon_password:'el-input__icon el-icon-eyes',
          showPassword:false,
          showDialog:false,
          tableData:[],
          username:'',
          password:'',
          form:{
            username:'',
            password:''
          },
          rules:{
            username:[{ required: true,message: '请输入账号名称', trigger: 'blur' }],
            password:[{ required: true,message: '请输入账号密码', trigger: 'blur' }],
          },
      }
  },
  methods:{
      //查看密码
      showPasswords(){
        if( this.passwordType=="text"){
            this.passwordType="password";
            //更换图标
            this.icon_password="el-input__icon el-icon-eyes";
        }else {
            this.passwordType="text";
            this.icon_password="el-input__icon el-icon-eyes_sel";
        };
      },
      getTableData(){
          this.tableData = [];
          DataService.getDmUserInfo().then(res=>{
              this.tableData.push({'username':res.data.username,'password':res.data.password});
              this.username = res.data.username;
              this.password = res.data.password
          }).catch(err=>{
              this.$message.error(err.message)
          })
      },
      edit(){
        this.form = {
            username:this.username,
            password:this.password
        }
        this.showDialog = true;
      },
      //提交表单
    submit(){
      this.$refs.edit.validate((valid)=>{
        if(valid){
            DataService.updateDmUserInfo({...this.form}).then(res=>{
              this.$message.success('编辑成功')
              this.showDialog = false;
              this.getTableData();
            }).catch(err=>{
              this.$message.error(err.message)
            })
        }else{
          this.$message.error("请检查必填项");
          return false;
        }
      })
    },
    canel(){
      this.showDialog = false;
    },
  },
  mounted(){
      this.getTableData()
      var aaa = 100;
  }
}
</script>

<style>

</style>